import { useCallback, useState } from "react";

type useSignDocumentProps = {
  onSignDocumentCallback: (file?: File | null) => void;
};

export default function useSignDocument({
  onSignDocumentCallback
}: useSignDocumentProps) {
  const [showSignDialog, setShowSignDialog] = useState(false);

  const handleShowSignDocumentDialog = useCallback(() => {
    setShowSignDialog(true);
  }, []);

  const handleCloseSignDocumentDialog = useCallback(() => {
    setShowSignDialog(false);
  }, []);

  const handleSubmitSignature = useCallback(
    async (files: File[]) => {
      let file: File | undefined = undefined;
      if (files?.length > 0) {
        file = files[0];
      }

      onSignDocumentCallback(file);
      handleCloseSignDocumentDialog();
    },
    [handleCloseSignDocumentDialog, onSignDocumentCallback]
  );

  return {
    showSignDialog,
    handleSubmitSignature,
    handleShowSignDocumentDialog,
    handleCloseSignDocumentDialog
  };
}
